class Cache {
  cache = new Map();
  ttl = 0;

  constructor(ttl: number) {
    this.ttl = ttl;
  }

  put(item: any) {
    const timestamp = new Date().getTime();
    const expired = timestamp + this.ttl;
    this.cache.set(item, expired);
  }

  has(item: any) {
    const timestamp = new Date().getTime();
    const cacheTimestamp = this.cache.get(item);
    if (!cacheTimestamp) {
      return false;
    }
    if (timestamp > cacheTimestamp) {
      this.cache.delete(item);
      return false;
    }
    return true;
  }
}

export default Cache;
